import clsx from "clsx";
import { FunctionComponent, useState } from "react";

import {
  button,
  copyLinkContainer,
  copyLinkText,
  icon,
} from "@ui/components/article/ShareButtons/ShareButtons.css";
import LinkIcon from "@ui/components/icon/LinkIcon";
import { ArticleLayout } from "@ui/components/ledes/ledes.types";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

interface Props {
  url: string;
  layout: ArticleLayout | "stream" | "video";
  className?: string;
  buttonClassName?: string;
  iconClassName?: string;
  analyticsPayload?: Record<string, any>;
}

const ShareButtonsCopyLink: FunctionComponent<Props> = ({
  url,
  layout,
  className,
  buttonClassName,
  iconClassName,
  analyticsPayload,
}) => {
  const analytics = useAnalytics();
  const [isCopied, setIsCopied] = useState(false);

  const handleClick = () => {
    analytics?.emit(
      analyticsPayload || {
        event: "social_share",
        social_share: { platform: "copy link" },
      },
    );

    navigator.clipboard
      .writeText(url)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 2000);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <div className={clsx(copyLinkContainer, className)}>
      <button
        aria-label="Copy link"
        onClick={handleClick}
        className={buttonClassName || button[layout]}
      >
        <LinkIcon className={iconClassName || icon[layout]} />
      </button>
      {isCopied && <span className={copyLinkText}>Link Copied!</span>}
    </div>
  );
};

export default ShareButtonsCopyLink;
